import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicDocumentFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 1.5h4.6v3.4c0 .83.67 1.5 1.5 1.5h3.4V13c0 .83-.67 1.5-1.5 1.5H4A1.5 1.5 0 012.5 13V3c0-.83.67-1.5 1.5-1.5zM4.75 8c0-.41.34-.75.75-.75h5a.75.75 0 010 1.5h-5A.75.75 0 014.75 8zm.75 2.25a.75.75 0 000 1.5H8a.75.75 0 000-1.5H5.5zm8-4.75l-4-4v2.7c0 .72.58 1.3 1.3 1.3h2.7z"
      />
    </svg>
  );
}

SvgBasicDocumentFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicDocumentFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicDocumentFilled svgRef={ref} {...props} />
));
export default ForwardRef;
